var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale[_vm.lang.lang]}},[_c('div',{attrs:{"id":"app"}},[_c('userInfoBox',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPerson),expression:"showPerson"}]}),(_vm.$store.state.editPwdvisible)?_c('editPwd'):_vm._e(),(_vm.$store.state.editNamevisible)?_c('editName'):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }